module.exports = __webpack_public_path__ + "static/shutterstock@2x-f623b6e7dc28f48d274dd044367c6379.png";